import { render, staticRenderFns } from "./NotificationPhone.vue?vue&type=template&id=d5f256bc&scoped=true"
import script from "./NotificationPhone.vue?vue&type=script&lang=ts"
export * from "./NotificationPhone.vue?vue&type=script&lang=ts"
import style0 from "./NotificationPhone.vue?vue&type=style&index=0&id=d5f256bc&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5f256bc",
  null
  
)

export default component.exports